import { ComponentSingleStyleConfig } from "@chakra-ui/react";
import { focusRing, focusRingInvalid } from "../focusStyles";

export const buttonTheme: ComponentSingleStyleConfig = {
  baseStyle: ({ colorScheme }) => ({
    _hover: {
      backgroundColor: "gray.50",
    },

    _focus: {
      borderColor: `${colorScheme}.700`,
    },

    _focusVisible: {
      borderColor: `${colorScheme}.700`,
    },

    _active: {
      backgroundColor: "gray.100",
    },

    // when being used as a toggle in a dropdown
    "&[aria-expanded=true]": {
      borderColor: `${colorScheme}.700`,
      ...focusRing,
    },

    // error state on a form
    _invalid: {
      borderColor: "error.500",
      _hover: {
        borderColor: "error.500",
      },

      // whenever the element has focus (for any reason)
      _focus: {
        borderColor: "error.500",
        ...focusRingInvalid,
      },

      // only when the browser believes the user needs to see the focus indicator
      _focusVisible: {
        borderColor: "error.500",
        ...focusRingInvalid,
      },

      "&[aria-expanded=true]": {
        borderColor: "error.500",
        ...focusRingInvalid,
      },
    },
  }),
  variants: {
    link: {
      _hover: {
        backgroundColor: "transparent",
      },
      _active: {
        backgroundColor: "transparent",
      },
    },
    outline: ({ colorScheme }) => ({
      borderColor: `${colorScheme}.300`,
    }),

    selectorOptionItem: {
      height: "auto",

      // specifically for the text-only inputs, as they need a bit more space
      // visually if there is no icon.
      minH: "2.5rem",
      lineHeight: "base",
      px: 4,
      py: 2,
      borderRadius: 0,
      fontWeight: "normal",
      _hover: {
        bg: "gray.50",
      },

      _focus: {
        bg: "gray.50",
        outline: "none",
        boxShadow: "none",
        borderColor: "gray.200", // don't change the border color
      },

      _focusVisible: {
        bg: "gray.50",
        outline: "none",
        boxShadow: "none",
        borderColor: "gray.200",
      },

      _active: {
        bg: "gray.100",
      },
    },
  },
};
